import moment from 'moment'
import { FaBookMedical, FaEye, FaUserFriends } from 'react-icons/fa'
import { MdModeEdit, MdPersonAdd, MdUpdate } from 'react-icons/md'

import { Skeleton } from 'antd'
import SectionTitle from 'components/SectionTitle'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import {
  useBookQuery,
  useBookQuestionsQuery,
  useBookRoleQuery,
  useBookUsersQuery,
} from 'store/queries'

const ThingsToDo = () => {
  const { t } = useTranslation()
  const { bookId } = useParams()
  const { data: book } = useBookQuery(bookId)
  const { data: questions } = useBookQuestionsQuery(bookId)
  const { data: users } = useBookUsersQuery(bookId)
  const { data: role } = useBookRoleQuery(bookId)

  const isEditorOrPurchaser =
    role?.name === 'Purchaser' || role?.name === 'Editor'

  const upcomingPrompt = questions
    .filter((q) => {
      return q.is_sent === 0 && q.tags
    })
    .sort((t1, t2) =>
      t1.will_send_on_datetime > t2.will_send_on_datetime ? 1 : -1,
    )
    .at(0)

  // Pending prompts for user to answer.
  const questionsToAnswer = questions
    .map((q) => {
      return {
        ...q,
        answer: q.answers.find(
          (a) => a.user_id === role?.id && a.is_submitted === 0,
        ),
      }
    })
    .filter((q) => {
      return q.is_sent && q.answer
    })

  const unregisteredUsersCount = users?.filter((u) => !u.cognito_id).length || 0

  const unsharedStoriesCount = questions?.filter((q) => {
    let _answers = q.answers
    return (
      q.is_sent &&
      (_answers.filter((_a) => parseInt(_a.is_submitted) === 0).length ||
        _answers.length === 0)
    )
  }).length

  return (
    <div className="section-container">
      {book?.id ? (
        <>
          <div>
            <div className="bb-line p1020">
              <SectionTitle>{t('things_to_do')}</SectionTitle>
            </div>
          </div>

          <div>
            {book.is_published ? (
              <div className="bb-line p20201040">
                <div className="things-to-do-action">
                  <FaBookMedical size={20} className="icon-option" />{' '}
                  <p className="pl40">Book has been published!</p>
                </div>
              </div>
            ) : (
              <>
                {role?.name === 'Purchaser' &&
                  !book?.has_checked_prompt_freq && (
                    <div className="bb-line p20201040">
                      <Link to={`/dashboard/book/${bookId}/stories/frequency`}>
                        <div className="things-to-do-action">
                          <MdUpdate size={20} className="icon-option" />
                          <p className="pl40">
                            Change how frequently story prompts get sent out to
                            the Author
                          </p>
                        </div>
                      </Link>
                    </div>
                  )}

                {questions.filter((q) => q.is_sent === 0).length === 0 &&
                  isEditorOrPurchaser && (
                    <div className="bb-line p20201040">
                      <div className="things-to-do-action">
                        <Link
                          to={`/dashboard/book/${bookId}/stories/prompt-catalog`}
                        >
                          <FaBookMedical size={20} className="icon-option" />{' '}
                          <p className="pl40"> {t('no_more_story')} </p>
                        </Link>
                      </div>
                    </div>
                  )}

                {isEditorOrPurchaser && upcomingPrompt && (
                  <div className="bb-line p20201040">
                    <Link
                      to={`/dashboard/book/${bookId}/stories/view/all?question=${upcomingPrompt.id}&edit_roles=true`}
                    >
                      <div className="things-to-do-action">
                        <FaUserFriends size={20} className="icon-option" />
                        <p className="pl40">
                          {' '}
                          {t('review_roles')} &ldquo;{upcomingPrompt.dsply_text}
                          &rdquo; {t('sending_on')}{' '}
                          {upcomingPrompt.will_send_on_datetime
                            ? moment(
                                upcomingPrompt.will_send_on_datetime,
                              ).format('MM/YY')
                            : moment(upcomingPrompt.sent_datetime).format(
                                'MM/YY',
                              )}{' '}
                        </p>
                      </div>
                    </Link>
                  </div>
                )}
                {isEditorOrPurchaser && unsharedStoriesCount !== 0 && (
                  <div className="bb-line p20201040">
                    <Link
                      to={`/dashboard/book/${bookId}/stories/view/not-shared`}
                    >
                      <div className="things-to-do-action">
                        <FaEye size={20} className="icon-option" />{' '}
                        <p className="pl40">
                          {' '}
                          {t('review')} {unsharedStoriesCount}{' '}
                          {t('stories_not_shared')}
                        </p>
                      </div>
                    </Link>
                  </div>
                )}

                {isEditorOrPurchaser && unregisteredUsersCount !== 0 && (
                  <div className="bb-line p20201040">
                    <Link to={`/dashboard/book/${bookId}/friends/invites`}>
                      <div className="things-to-do-action">
                        <MdPersonAdd size={20} className="icon-option" />{' '}
                        <p className="pl40">
                          {' '}
                          {t('check_on')} {unregisteredUsersCount}{' '}
                          {t('not_yet_registered')}{' '}
                        </p>
                      </div>
                    </Link>
                  </div>
                )}

                {questionsToAnswer.map((q) => (
                  <div key={q.answer.id} className="bb-line p20201040">
                    <div className="things-to-do-action">
                      <Link
                        to={`/dashboard/book/${bookId}/stories/view/shared?question=${q.id}&answer=${q.answer.id}&is_edit=true`}
                      >
                        <MdModeEdit size={20} className="icon-option" />{' '}
                        <p className="pl40">
                          {' '}
                          {t('complete_and_share')}: &ldquo;
                          {q.dsply_text}
                          &rdquo;
                        </p>
                      </Link>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </>
      ) : (
        <Skeleton active paragraph={{ rows: 6 }} />
      )}
    </div>
  )
}

export default ThingsToDo
